import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Fires a GA4 `page_view` event whenever React Router changes location.
 * gtag.js is loaded from index.html with `send_page_view: false`, so this
 * hook is the single source of truth for pageviews in the SPA.
 */
export function usePageviewTracking() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
}

/**
 * Fire a custom GA4 event. Silently no-ops if gtag failed to load
 * (e.g., visitor with adblocker) — analytics must never break product flow.
 *
 * Naming: snake_case, GA4-recommended verbs (view, select, share, etc.).
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch {
    /* no-op */
  }
}
